
export default () => ({
    loading: true,
    trailTypes: [],
    currentTrailType: null
})
